import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormats';

import { IErknmSuspensionEvent } from '../interfaces/IErknmSuspensionEvent';
import { parseErknmValue } from './parseErknmValue';

export const getSuspensionEvents = (
  passportData: IKnmPreview | undefined,
  erknmField: 'pmErknm' | 'inspectionErknm',
) => {
  const suspensionEvents: IErknmSuspensionEvent[] = [];

  passportData?.[erknmField]?.events?.forEach(item => {
    const eventValue = item.event?.value && parseErknmValue(item.event.value);
    const addedSuspensionEvents: IErknmSuspensionEvent[] =
      item.suspension?.map(stopItem => ({
        ...stopItem,
        event: eventValue && eventValue.title,
        startDate: stopItem.startDate && formatDate({ date: stopItem.startDate, dateFormat: DATE_FORMAT_LONG_FNS }),
        stopDate: stopItem.stopDate && formatDate({ date: stopItem.stopDate, dateFormat: DATE_FORMAT_LONG_FNS }),
        decisionDateTime:
          stopItem.decisionDateTime &&
          formatDate({ date: stopItem.decisionDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE }),
      })) || [];

    suspensionEvents.push(...addedSuspensionEvents);
  });
  suspensionEvents.sort((a, b) => {
    return a.dateCreate && b.dateCreate ? new Date(a.dateCreate).valueOf() - new Date(b.dateCreate).valueOf() : 0;
  });

  return suspensionEvents;
};
